import {QueryClient} from 'react-query';

export const goalQueryKeys = [
  'my-goals-v2',
  'notification-goals',
  'initGoals',
  'direct_reports',
  'all_goals',
  'kpis-page',
  'key-results',
] as const;

export const invalidateGoalQueries = (queryClient: QueryClient) =>
  Promise.all(
    goalQueryKeys.map((queryKey) => queryClient.invalidateQueries([queryKey])),
  );
